import { render, staticRenderFns } from "./Relations.vue?vue&type=template&id=75324a73&"
import script from "./Relations.vue?vue&type=script&lang=js&"
export * from "./Relations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports